/**
 * Handle async/await error without try/catch
 * https://blog.grossman.io/how-to-write-async-await-without-try-catch-blocks-in-javascript/
 *
 * Usage:
 *  let error, response
 *  [error, response] = await to([call to promise])
 *  if (error) // manage error here with a return Promise.reject(error) or a throw error
 *  // manage response here
 */
export default function to (promise) {
  return promise
    .then(data => [null, data])
    .catch(err => [err])
}
